import { render, staticRenderFns } from "./GlobalFormsContentDisplay.vue?vue&type=template&id=28610a80"
import script from "./GlobalFormsContentDisplay.vue?vue&type=script&lang=js"
export * from "./GlobalFormsContentDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports